import { createLucideIcon } from "lucide-react";

export const DocumentValidation = createLucideIcon(
    "DocumentValidation",
    [
        [
            "path",
            {
                d: "M10.4706 2.75C10.8848 2.75 11.2206 2.4142 11.2206 2C11.2206 1.5858 10.8848 1.25 10.4706 1.25V2.75Z",
                key: "13hyl7",
            },
        ],
        [
            "path",
            {
                d: "M10.4706 22V21.25C8.454 21.25 7.0129 21.2486 5.9178 21.1095C4.8401 20.9727 4.2118 20.7142 3.7555 20.2832L3.2405 20.8284L2.7255 21.3737C3.5097 22.1142 4.4999 22.4415 5.7288 22.5976C6.9404 22.7514 8.4941 22.75 10.4706 22.75V22Z",
                key: "182erm",
            },
        ],
        [
            "path",
            {
                d: "M10.4706 22V22.75V22Z",
                key: "b2de97",
            },
        ],
        [
            "path",
            {
                d: "M10.4706 2V1.25C8.4941 1.25 6.9404 1.2486 5.7289 1.4024C4.4999 1.5585 3.5097 1.8858 2.7255 2.6263L3.2405 3.1716L3.7555 3.7168C4.2118 3.2858 4.8401 3.0273 5.9178 2.8905C7.0129 2.7514 8.454 2.75 10.4706 2.75V2Z",
                key: "1vymws",
            },
        ],
        [
            "path",
            {
                d: "M11.5294 22V21.25H10.4706V22V22.75H11.5294V22Z",
                key: "1s918l",
            },
        ],
        [
            "path",
            {
                d: "M11.5294 22V21.25V22Z",
                key: "1stlzr",
            },
        ],
        [
            "path",
            {
                d: "M11.5294 22V22.75C13.5059 22.75 15.0596 22.7514 16.2712 22.5976C17.5001 22.4415 18.4904 22.1143 19.2745 21.3737L18.7595 20.8284L18.2445 20.2832C17.7882 20.7142 17.1599 20.9727 16.0822 21.1095C14.9871 21.2486 13.546 21.25 11.5294 21.25V22Z",
                key: "ylf4u",
            },
        ],
        [
            "path",
            {
                d: "M15 7.5C15 7.5 15.5 7.5 16 8.5C16 8.5 17.5882 6 19 5.5",
                key: "1wbkzq",
            },
        ],
        [
            "path",
            {
                d: "M18.7595 20.8284L19.2745 21.3737L18.7595 20.8284Z",
                key: "l4cv36",
            },
        ],
        [
            "path",
            {
                d: "M19.9999 14.4185L19.2499 14.4181C19.2491 16.1827 19.2356 17.4394 19.0858 18.3947C18.9401 19.3239 18.6785 19.8734 18.2445 20.2832L18.7595 20.8284L19.2745 21.3737C20.0343 20.6561 20.392 19.7476 20.5677 18.6271C20.7393 17.5328 20.7491 16.1482 20.7499 14.4189L19.9999 14.4185Z",
                key: "ruv0bd",
            },
        ],
        [
            "path",
            {
                d: "M2 10H2.75C2.75 8.092 2.7518 6.7408 2.8976 5.7166C3.0396 4.7186 3.3052 4.1421 3.7555 3.7168L3.2405 3.1716L2.7255 2.6263C1.9353 3.3726 1.5806 4.3247 1.4126 5.5052C1.2482 6.6596 1.25 8.1368 1.25 10H2Z",
                key: "7yuk2f",
            },
        ],
        [
            "path",
            {
                d: "M2 10H2.75H2Z",
                key: "1gfopu",
            },
        ],
        [
            "path",
            {
                d: "M2 14H1.25C1.25 15.8632 1.2482 17.3404 1.4126 18.4948C1.5806 19.6753 1.9353 20.6274 2.7255 21.3737L3.2405 20.8284L3.7555 20.2832C3.3052 19.8579 3.0396 19.2814 2.8976 18.2834C2.7518 17.2592 2.75 15.908 2.75 14H2Z",
                key: "ty9o7b",
            },
        ],
        [
            "path",
            {
                d: "M2 14H1.25H2Z",
                key: "1n9o9x",
            },
        ],
        [
            "path",
            {
                d: "M2 14H2.75L2.75 10H2H1.25L1.25 14H2Z",
                key: "nv1j6m",
            },
        ],
        [
            "path",
            {
                d: "M20.7499 14.4189C20.7501 14.0047 20.4145 13.6687 20.0003 13.6685C19.5861 13.6683 19.2501 14.0039 19.2499 14.4181L20.7499 14.4189Z",
                key: "1oykao",
            },
        ],
        [
            "path",
            {
                d: "M22 7C22 9.76142 19.7614 12 17 12C14.2386 12 12 9.76142 12 7C12 4.23858 14.2386 2 17 2C19.7614 2 22 4.23858 22 7Z",
                key: "16maci",
            },
        ],
        [
            "path",
            {
                d: "M7 13H11",
                key: "1w6emp",
            },
        ],
        [
            "path",
            {
                d: "M7 17L15 17",
                key: "13lt5m",
            },
        ],
    ],
);
